/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import websocket, {openWebsocket} from "../services/api/websocket";
import {whiteLabelData} from "../ui/theme"
import './main.css'
import { Layout } from '../ui/hoc/Layout';
// @FIXME temporary - move to ui

import HomeIcon from '@mui/icons-material/Home';
import MyDevicesIcon from '@mui/icons-material/DeviceHub';
import UserIcon from '@mui/icons-material/AccountCircleOutlined';

import InfoIcon from '@mui/icons-material/Info';
import {activateDevice, fetchDevices} from '../connectors/Devices/actions';
import clsx from 'clsx';
import { sendRequest, pingURL } from '../services/api/apiClient';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import green from '@mui/material/colors/green';
import amber from '@mui/material/colors/amber';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
//import { makeStyles } from '@mui/styles';
import Toaster from "../ui/components/Toaster/"
import toast from "../utils/ToasterService"


import ConfigureIcon from '@mui/icons-material/BuildOutlined';
import SetupIcon from '@mui/icons-material/SettingsOutlined';
import {apiClient} from "../services/api";
import log from 'loglevel'

import LanguageIcon from '@mui/icons-material/Language';

import {  Trans } from 'react-i18next';
import {t} from 'i18next'
import Grid from '@mui/material/Grid';

if(process.env.NODE_ENV === 'production'){
  log.setLevel("info")
} else {
  log.setLevel("debug")
}


const mapStateToProps = (state, ownProps) => ({
  title: state.application.title,
  devices: state.devices.map,
  activeDeviceId: state.devices.active,
  currentNavigationPath: ownProps.location.pathname,
    user: state.authentication.user,
});

const mapDispatchToProps = dispatch => ({
  activateDevice: id => dispatch(activateDevice(id)),
    fetchDevices: () => dispatch(fetchDevices()),
});
/**
 * Application
 */

var syncInterval = null;
class Application extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    activeDeviceId: PropTypes.string,
    devices: PropTypes.shape({}),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,

    activateDevice: PropTypes.func.isRequired,

  }

  state = {
    online: true,
      toast: {
        open: true,
          variant: "success",
          message: ""
      },
      lastSendClickInterval: true,
      langDialogOpen: false
  }

  static defaultProps = {
    title: 'Anwendung wird geladen',
    children: null,
    navigationItems: [
      {
        label: <Trans i18nKey="PageTitles.areas"/>,
        icon: <HomeIcon sx={{color:"#fff"}} color={'#fff'}/>,
        path: '/',
        enabled: true,
      },
      {
        label: <Trans i18nKey="PageTitles.devices"/>,
        icon: <MyDevicesIcon sx={{color:"#fff"}} color={'#fff'}/>,
        path: '/devices',
        enabled: true,
      },
      {
        label: <Trans i18nKey="PageTitles.user"/>,
        icon: <UserIcon sx={{color:"#fff"}} color={'#fff'}/>,
        path: '/profile',
        enabled: true,
      },
      {
        label: <Trans i18nKey="PageTitles.settings"/>,
        icon: <ConfigureIcon sx={{color:"#fff"}} color={'#fff'}/>,
        path: '/settings',
        enabled: true,
      },
      {
        label: <Trans i18nKey="PageTitles.setup"/>,
        icon: <SetupIcon sx={{color:"#fff"}} color={'#fff'} />,
        path: '/setupAuth',
        enabled: true,
      },
      {
        label: <div><Trans i18nKey="PageTitles.about"></Trans>{whiteLabelData.name}</div>,
        icon: <InfoIcon sx={{color:"#fff"}} color={'#fff'}/>,
        path: '/about',
        enabled: true,
      },
    ],
  }


  handleChangeStatus = (event) => {
    this.setState({ online: navigator.onLine });
    if(this && this.props.updateStatus) {
        this.props.updateStatus({
          connection: {
            online: navigator.onLine
          }
        });
    }

    // use action to provide infos to the reducer
  }

    receiveMessage(evt) {
        if(evt.data.type === "stopSyncing") {
           if(syncInterval != null) {
               clearInterval(syncInterval);
               syncInterval = null;
           }
        }
        if(evt.data.type === "startSyncing") {
            if(syncInterval == null) {
                syncInterval = setInterval(() => {
                    if (typeof this.props !== "undefined") {

                        this.props.fetchDevices(this.props.accessToken);


                    }
                }, 10000);;
            }
        }
    }

  componentDidMount () {
      if(this.props.user) {
          openWebsocket(this.props.user._id, this.addWebsocketListener.bind(this));
      }

    window.addEventListener('online', this.handleChangeStatus);
    window.addEventListener('offline', this.handleChangeStatus);
    window.addEventListener("message", this.receiveMessage, false);

    if(syncInterval == null) {
       /* syncInterval = setInterval(() => {
            if (typeof this.props !== "undefined") {
                this.props.fetchDevices(this.props.accessToken);
            }
        }, 10000);*/
    }



  }

    addWebsocketListener(ws) {
      // log.debug("addWebsocketlistener", ws);
        if(ws) {
             ws.addEventListener("message", this.onWebsocketMessage.bind(this))
            // ws.onmessage = function (evt) {
            //     var received_msg = evt.data;
            //     log.debug("Websocket message", received_msg);
            //     alert("Message is received...");
            // };
        }
    }

  componentWillUnmount() {

      if(websocket) {
          websocket.removeEventListener("onmessage", this.onWebsocketMessage.bind(this))
      }
  }

  onWebsocketMessage() {
      log.debug("trigger reload")
          this.props.fetchDevices((success) => {
              // if(success.length > 0 && !this.props.activeDeviceId)
          });

  }

  checkConnectionToServer=()=>{
    sendRequest('get', pingURL)
    .then(() => {
      //console.log('Response Ok: Server working!');
    })
    .catch(error => {
      //console.error('Cannot Connect to Server:', error);
      //Server Failure Toast here
      toast.error(t('Global.toast_server_disconnect'));
    });
  }

  onTest = () => {
    log.debug("Application On Test!")
  }

  myChangeEvent = () => {
    this.checkConnectionToServer()
    log.debug("MY CHANGE EVENT!")
    var data = { deviceid: this.props.currentDeviceId }
    apiClient.post('control/settings/store', data)
      .then(res => {
        if (res.status === 200) {
          this.props.activateDevice()
        }
      })
  }

  closeLanguageDialog = () => {
    // console.log("Layout: Language closed")
    this.setState({...this.state, langDialogOpen: false})
    window.location.reload()
    // this.render()
  }

  openLanguageDialog = () => {
    this.setState({...this.state, langDialogOpen: true})
  }

  checkConnectionToServer=()=>{
    sendRequest('get', pingURL)
    .then(() => {
      //console.log('Response Ok: Server working!');
    })
    .catch(error => {
      //console.error('Cannot Connect to Server:', error);
      //Server Failure Toast here
      toast.error(t('Global.toast_server_disconnect'));
    });
  }

  render() {
    window.document.title = this.props.title;
      const classes = useStyles2;
      log.debug(this.props.children)
    
      //Funtion call hear rerenders constantly on naviation within protected routes
      this.checkConnectionToServer()

  


    return (

      <Grid sx={{}}>
        <Layout
        langDialogOpen={this.state.langDialogOpen}
        closeLanguageDialog={this.closeLanguageDialog}

        //fix language dialog
        openLanguageDialog={this.openLanguageDialog}
          showNavigationMenu={this.props.showNavigationMenu}
          navigationItems={this.props.navigationItems}
          currentNavigationPath={this.props.currentNavigationPath}
          devices={this.props.devices}
          activeDeviceId={this.props.activeDeviceId}
          onSelectChange={this.props.activateDevice}
          onTest={this.props.fetchDevices}
          >
          {this.props.children}
        </Layout>
      </Grid>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Application));


const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const useStyles1 = {
    success: {
        backgroundColor: "green",
    },
    error: {
        backgroundColor: {

                main: 'rgba(127, 45, 67, 0.92)',
                dark: 'rgba(127, 45, 67, 1)',
                contrastText: 'rgba(127, 45, 67, 0.7)',

        },
    },
    info: {
        backgroundColor: "blue",
    },
    warning: {
        backgroundColor: "orange",
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: 1,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
};

function MySnackbarContentWrapper(props) {
    const classes = useStyles1;
    const { className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
    var backgroundColor = "#479F4B";
    if(variant === "error") {
        backgroundColor = "#D03134"
    }
    if(variant === "success") {
        backgroundColor = "#479F4B"
    }
    if(variant === "warning") {
        backgroundColor = "#FD9F28"
    }

    if(variant === "info") {
        backgroundColor = "#2178CF"
    }

    return (
        <SnackbarContent
            style={{backgroundColor: backgroundColor, zIndex: 20000}}
            className={variant}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" style={{display: "flex", alignItems: "center"}} className={classes.message}>
          <Icon style={{marginRight: 5}} className={clsx(classes.icon, classes.iconVariant)} />
                    {message}
        </span>
            }
            action={[
                <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
                    <CloseIcon className={classes.icon} />
                </IconButton>,
            ]}
            {...other}
        />
    );
}

const useStyles2 ={
    margin: {
        margin: 1,
    },
};
